/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityShieldCheckIcon16Light } from './SecurityShieldCheckIcon16Light';
import { SecurityShieldCheckIcon16Regular } from './SecurityShieldCheckIcon16Regular';
import { SecurityShieldCheckIcon16Solid } from './SecurityShieldCheckIcon16Solid';
import { SecurityShieldCheckIcon20Light } from './SecurityShieldCheckIcon20Light';
import { SecurityShieldCheckIcon20Regular } from './SecurityShieldCheckIcon20Regular';
import { SecurityShieldCheckIcon20Solid } from './SecurityShieldCheckIcon20Solid';
import { SecurityShieldCheckIcon24Regular } from './SecurityShieldCheckIcon24Regular';
import { SecurityShieldCheckIcon24Solid } from './SecurityShieldCheckIcon24Solid';
import { SecurityShieldCheckIcon32Regular } from './SecurityShieldCheckIcon32Regular';
import { SecurityShieldCheckIcon64Regular } from './SecurityShieldCheckIcon64Regular';
var sizes = {
    16: {
        light: SecurityShieldCheckIcon16Light,
        regular: SecurityShieldCheckIcon16Regular,
        solid: SecurityShieldCheckIcon16Solid,
    },
    20: {
        light: SecurityShieldCheckIcon20Light,
        regular: SecurityShieldCheckIcon20Regular,
        solid: SecurityShieldCheckIcon20Solid,
    },
    24: {
        regular: SecurityShieldCheckIcon24Regular,
        solid: SecurityShieldCheckIcon24Solid,
    },
    32: {
        regular: SecurityShieldCheckIcon32Regular,
    },
    64: {
        regular: SecurityShieldCheckIcon64Regular,
    },
};
export var SecurityShieldCheckIcon = forwardRef('SecurityShieldCheckIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
